import { render, staticRenderFns } from "./SpecificationResources.vue?vue&type=template&id=2f356ba6"
import script from "./SpecificationResources.vue?vue&type=script&lang=js"
export * from "./SpecificationResources.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports